/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
// eslint-disable-next-line no-underscore-dangle
(window as any).__Zone_disable_customElements = true;

/**
 * Prevents zone.js from patching inline on* event handler properties on
 * HTMLIFrameElement instances. When an iframe holds cross-origin content
 * (e.g. play.odiho.com), zone.js calling the original onload/onerror getter
 * with the cross-origin iframe as `this` triggers a browser Same-Origin
 * Policy violation: "Blocked a frame with origin X from accessing frame Y".
 *
 * Note: addEventListener() still works normally through EventTarget patching.
 */
// eslint-disable-next-line no-underscore-dangle
(window as any).__Zone_ignore_on_properties = [
  {
    target: typeof HTMLIFrameElement !== 'undefined' ? HTMLIFrameElement.prototype : null,
    ignoreProperties: typeof HTMLIFrameElement !== 'undefined'
      ? Object.getOwnPropertyNames(HTMLIFrameElement.prototype)
          .filter((n: string) => n.startsWith('on') && n.length > 2)
          .map((n: string) => n.substring(2))
      : [],
  },
];
